import React from "react";
import { PlainButton, Thumbnail, Tooltip } from "@culturehq/components";

import { ProfileLink } from "app/links";
import AttendeesModal from "components/event/modals/AttendeesModal";
import getUserName from "app/utils/getUserName";

const LIMIT = 5;

const Attendees = ({ event, onEventUpdate }) => {
  let { rsvpPreview } = event;

  if (!rsvpPreview || rsvpPreview.length < 1) {
    return null;
  }

  let extra = 0;

  if (rsvpPreview) {
    rsvpPreview = rsvpPreview.slice(0, LIMIT);
    extra = event.acceptedCount - rsvpPreview.length;
  }

  return (
    <div>
      <span className="whos-coming">Who&#39;s coming: </span>
      <div className="rsvps-list tooltip-rsvp">
        {rsvpPreview.map(({ user }) => (
          <ProfileLink key={user.id} user={user}>
            <Tooltip tip={getUserName(user)}>
              <Thumbnail className="Thumbnail" image={user.avatar.thumbUrl} />
            </Tooltip>
          </ProfileLink>
        ))}

        {extra > 0 && (
          <AttendeesModal event={event} onEventUpdate={onEventUpdate}>
            {onTrigger => (
              <PlainButton className="extra" onClick={onTrigger}>
                +{extra}
              </PlainButton>
            )}
          </AttendeesModal>
        )}
      </div>
    </div>
  );
};

export default Attendees;
